import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const NavbarContainer = styled('section')`
  ${flexCenter}

  align-items: flex-start;
  background-color: var(--london-fog);
  height: var(--nav-bar-height);
  justify-content: space-between;
  padding: 10px;
  position: relative;
`

const NavbarLeft = styled('div')`
  ${flexCenter}

  justify-content: flex-start;

  ${mediaQuery('tablet')} {
    max-width: 70%;
  }
`

const NavbarRight = styled('div')`
  ${flexCenter}

  justify-content: flex-end;

  & .mdi {
    font-size: 1.5rem;
  }

  ${mediaQuery('tablet')} {
    max-width: 30%;
  }
`

export { NavbarContainer, NavbarLeft, NavbarRight }
